import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {KeyboardDatePicker} from '@material-ui/pickers';
import {ReactComponent as Calendar} from './calendar.svg';
import './DatePickerMUI.scss';
import {TextField} from '@material-ui/core';
import {useTranslation} from 'react-i18next';

const DatePickerMUI = ({
  autoOk = true,
  className = '',
  clearable,
  disableFuture = false,
  disablePast = false,
  disableToolbar = false,
  disabled,
  emptyLabel = '',
  format = 'DD/MM/YYYY',
  inputVariant = 'outlined',
  maxDate,
  minDate,
  maxDateMessage = 'Greater than maximum date',
  minDateMessage = 'Less minimum date',
  onChange,
  openTo,
  orientation = 'portrait',
  readOnly,
  value = null,
  variant = 'filled',
  views = ['year', 'month', 'date']
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {t} = useTranslation();

  const handleOpen = () => !disabled && setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const TextFieldComponent = (props) => (
    <TextField
      onClick={handleOpen}
      {...props}
      InputProps={{
        ...props.InputProps,
        readOnly: true // Prevent direct input
      }}
    />
  );

  return (
    <KeyboardDatePicker
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      autoOk={autoOk}
      className={`date-picker-mui${className && ` ${className}`}`}
      clearable={clearable}
      disableFuture={disableFuture}
      disablePast={disablePast}
      disableToolbar={disableToolbar}
      disabled={disabled}
      emptyLabel={emptyLabel}
      format={format}
      inputVariant={inputVariant}
      label={t('DatePickerMUI.label')}
      maxDate={maxDate}
      minDate={minDate}
      maxDateMessage={maxDateMessage}
      minDateMessage={minDateMessage}
      onChange={onChange}
      openTo={openTo}
      orientation={orientation}
      readOnly={readOnly}
      value={value}
      variant={variant}
      views={views}
      mask='__.__.____'
      placeholder={'__.__.____'}
      keyboardIcon={<Calendar />}
      TextFieldComponent={TextFieldComponent}
    />
  );
};

DatePickerMUI.propTypes = {
  autoOk: PropTypes.bool,
  className: PropTypes.string,
  clearable: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  disableToolbar: PropTypes.bool,
  disabled: PropTypes.bool,
  emptyLabel: PropTypes.string,
  format: PropTypes.string,
  inputVariant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  label: PropTypes.string,
  maxDate: PropTypes.any,
  maxDateMessage: PropTypes.string,
  minDate: PropTypes.any,
  minDateMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  openTo: PropTypes.oneOf(['date', 'year', 'month']),
  orientation: PropTypes.oneOf(['portrait', 'landscape']),
  readOnly: PropTypes.bool,
  value: PropTypes.any,
  variant: PropTypes.oneOf(['dialog', 'inline', 'static']),
  views: PropTypes.arrayOf(PropTypes.string)
};

export default DatePickerMUI;
